import { EmployeeNodeModel, UpdateAndDeleteModalInfo } from '../../models';

export const UPDATE_AND_DELETE_MODAL_INFO_EMPTY: UpdateAndDeleteModalInfo = {
    startDate: '',
    endDate: '',
    employee: {} as EmployeeNodeModel[],
    interruption: [[]],
    interruptionCopy: [[]],
};
